// extracted by mini-css-extract-plugin
export var editor = "_1b-0";
export var flowSidebar = "_4l-2";